import { Link as RouterLink, Outlet } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// components
import Logo from '../components/Logo';
import IntercomWidget from '../common/components/IntercomWidget';
import Footer from '../components/common/Footer';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0)
  }
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <HeaderStyle>
        <RouterLink to="/check-transaction-status">
          <Logo />
        </RouterLink>
      </HeaderStyle>
      <Box sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
      <IntercomWidget />
    </Box>
  );
}
